<template>
  <div class="ubv" style="height: 100%">
    <div class="search-hd">
      <div class="item-title">
        <span>{{ $t('asm_rework_item.fgxxx') }}</span>
        <span v-if="itemGroup">({{ itemGroup.productCode }} - {{ itemGroup.itemVersion }}）</span>
      </div>
      <el-form :inline="true" @submit.native.prevent>
        <el-form-item v-if="funcView.maintain_rework_del_item && itemGroup && !itemGroup.isPublish">
          <el-button type="primary" :disabled="!itemSelected.length" @click="onDelete()">
            <i class="icon icon-shanchu" style="color: #ffffff !important"></i>
            {{ $t('asm_rework_item.shan_chu_xiang_mu') }}
          </el-button>
        </el-form-item>
        <el-form-item style="float: right">
          <search-input v-model="formSearch.search" width="200px" :placeholder="$t('asm_rework_item.xmcljbh')" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
        <el-form-item style="float: right">
          <custom-select
            :auto="false"
            type="tree"
            ref="compTree"
            url="reworkComponent"
            :show-all-levels="false"
            v-model="formSearch.componentCode"
            :params="{ productSn: itemGroup ? itemGroup.productSn : '' }"
            :props="{ label: 'componentName', value: 'componentCode', emitPath: false }"
            width="100%"
            @change="onPageChange({ page: 1 })"
            :placeholder="$t('asm_rework_item.qing_xuan_ze_wei_zhi')"
          ></custom-select>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-bd">
      <custom-table
        :type="funcView.maintain_rework_del_item ? 'checkbox' : null"
        v-model="itemSelected"
        index
        height="100%"
        tableCode="rework_version_info"
        :data="tableList"
        @filter="filterChange"
        @sort="sortChange"
      ></custom-table>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';

export default {
  props: {
    itemGroup: {
      type: Object,
    }
  },
  data() {
    return {
      itemSelected: [],
      formSearch: {
        search: '',
        orderType: '',
        orderBy: '',
        pageSize: 50,
        pageNum: 1,
        itemGroupId: '',
        componentCode: '',
      },
      totalRows: null,
      tableList: [],
    };
  },
  mounted() {
    this.init();
    this.getFuncView();
  },
  methods: {
    init: function () {
      this.formSearch.componentCode = '';
      this.$nextTick(() => {
        if (this.itemGroup && this.itemGroup.productSn) {
          this.$refs.compTree.getSelectList();
          this.onPageChange({ page: 1 });
        } else {
          this.$refs.compTree.list = [];
          this.tableList = [];
          this.totalRows = null;
        }
      });
    },
    getTableList() {
      this.formSearch.itemGroupId = this.itemGroup.itemGroupId;
      this.$getJSON(apis.reworkItemPage, this.formSearch).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    // 删除选择
    onDelete() {
      this.$showConfirm(this.$t('asm_rework_item.nqdyscxzfgxm'))
        .then(() => {
          this.$postJSON(
            apis.reworkItemDelete,
            this.itemSelected.map(t => t.itemId)
          ).then(() => {
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success',
            });
            this.getTableList();
          });
        })
        .catch(() => {});
    },
  },
};
</script>
